import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { ButtonColors } from '@ed---interne/ng-uui-components';
import { GrdfConsentService, GrdfConsent } from '../grdf-consent.service';

import { parseJwt } from 'src/app/shared/all.helpers';
import { GrdfAccessRightStatus } from '../../../grdf.models';

@Component({
    selector: 'app-grdf-consent-page',
    templateUrl: './grdf-consent-page.component.html',
    styleUrls: ['./grdf-consent-page.component.scss'],
})
export class GrdfConsentPageComponent {
    public GrdfAccessRightStatus = GrdfAccessRightStatus;
    public buttonColors = ButtonColors;

    consentForm: FormGroup;
    token: string | null = null;
    consentGiven: boolean = false;

    loading: boolean = true;
    error: boolean = false;
    consentData: Partial<GrdfConsent> | null = null;
    clientIdentity: string | null = null;
    clientSociety: string | null = null;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private grdfConsentService: GrdfConsentService,
    ) {
        this.consentForm = this.fb.group({
            dataConsumption: [false, Validators.requiredTrue],
            profileData: [false, Validators.requiredTrue],
            technicalData: [false, Validators.requiredTrue],
        });
    }

    async ngOnInit(): Promise<void> {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.token = params['token'];

            if (!this.token) {
                this.error = true;
                console.error('Token is missing');
                this.loading = false;
                return;
            }

            try {
                const consentStatus = await this.grdfConsentService.getEnedisConsentStatus(
                    this.token,
                );

                this.consentData = parseJwt(this.token) as Partial<GrdfConsent>;
                this.consentData.status = consentStatus.status;
                this.consentData.consentStart = consentStatus.consentStart;

                this.clientIdentity = [
                    this.consentData.clientRepresentativeName,
                    this.consentData.clientRepresentativeEmail,
                ].join(' / ');

                if (this.consentData!.clientSirenSiret) {
                    this.clientSociety = [
                        this.consentData.clientName,
                        this.consentData.clientSirenSiret,
                    ].join(' / ');
                }
            } catch (err: any) {
                console.error('Error getting current consent status', err);
                this.error = true;
            } finally {
                this.loading = false;
            }
        });
    }

    async onAccept() {
        if (this.consentForm.valid) {
            try {
                const result = await this.grdfConsentService.updateConsent(
                    this.token!,
                    GrdfAccessRightStatus.ACTIVE,
                );

                if (result.status === GrdfAccessRightStatus.ACTIVE) {
                    this.consentGiven = true;
                } else {
                    this.consentData!.status = result.status;
                }
            } catch (error: any) {
                console.error('Error accepting consent', error);
                this.error = true;
            }
        }
    }

    async onRevoke() {
        this.router.navigate(['/grdf-consent/revoked'], { queryParams: { token: this.token } });
    }
}
